<template>
  <article class="prices__section">
    <h3 class="section__subtitle">
      Consultas
    </h3>

    <transition name="fade">
      <section class="prices__list">
        <div class="prices__item">
          <div class="prices__col prices__col--left">
            <div class="prices__icon">
              <dr-icon
                color="#56bdd2"
                fill="#56bdd2"
                name="agenda"
              />
            </div>

            <div class="prices__name">
              Consulta particular
            </div>
          </div>

          <div class="prices__col prices__col--right">
            <div v-if="!isEditing" class="prices__price">
              <template name="fade">
                <span v-if="!isLoading">
                R$ {{ formData.value.value.raw | TO_BRL }}
                </span>
              </template>

              <template name="fade">
                <dr-loader
                  v-if="isLoading"
                  class="prices__price-loader"
                />
              </template>
            </div>

            <div v-if="isEditing" class="prices__price">
              <dr-field
                v-for="(field, name) in formData"
                :key="'field_healthInsurance_'+name"
                :id="name"
                :ref="name"
                :form.sync="formData"
                :field.sync="field"
                :value.sync="field.value"
                :validators.sync="$v.formData[name].raw"
                :class="field.classes"
                :edited-value.sync="field.editedValue"
                prefix="privatePrice_"
              />
            </div>

            <div class="prices__actions">
              <template name="fade">
                <button
                  v-if="!isEditing"
                  class="prices__actions-btn prices__actions-btn--edit"
                  @click="isEditing = !isEditing"
                >
                  <dr-icon
                    color="#4a4a4a"
                    fill="#4a4a4a"
                    name="edit"
                  />
                </button>
              </template>

              <template name="fade">
                <button
                  v-if="isEditing"
                  @click="save()"
                  class="prices__actions-btn prices__actions-btn--edit"
                >
                  <i class="icon icon-check" />
                </button>
              </template>
            </div>
          </div>
        </div>
      </section>
    </transition>
  </article>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import drField from '@/components/form/field'
import { mapGetters } from 'vuex'

const formData = {
  value: {
    type: 'currency',
    name: 'price',
    mask: '#####',
    placeholder: 'Digite o preço',
    value: {
      converted: null,
      raw: 0
    }
  }
}

const validations = {
  value: {
    required,
    isNotNull (value) {
      return ('converted' in value) ? (!!value.converted) : false
    }
  }
}

export default {
  name: 'DrPrices',

  components: {
    drField
  },

  validations: {
    formData: validations
  },

  data () {
    return {
      isEditing: false,
      isLoading: false,
      formData
    }
  },

  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    }),

    prefix () {
      return this.fn_IS_DOCTOR()
        ? '/doctor'
        : `/secretary/doctor/${this.$route.params.doctorId}`
    }
  },

  watch: {
    office: {
      deep: true,
      immediate: false,
      handler () {
        this.getOfficeConsultationPrice()
      }
    }
  },

  created () {
    this.getOfficeConsultationPrice()
  },

  methods: {
    getOfficeConsultationPrice () {
      const url = `${this.prefix}/doctor_office/${this.office.id}`

      this.isLoading = true
      this.fn_SHOW_PROGRESS()
      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          this.formData.value.value.raw = res.data['private_specialty_price']
          this.formData.value.value.converted = this.$options.filters.TO_BRL(res.data['private_specialty_price'])
        })
        .catch((err) => {
          console.log('err\n', err)
          // this.handleError(err)
        })
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.isLoading = false
        })
    },

    save () {
      const price = this.formData.value.value.raw

      this.fn_SHOW_PROGRESS()
      this.$http
        .put(
          `/doctor/doctor_office/${this.office.id}/private_specialty_price`,
          { private_specialty_price: { privateSpecialtyPrice: price } },
          this.$store.getters.getAuthHeader
        )
        .then((res) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Valor da consulta salvo com sucesso.',
            size: 'md',
            active: true
          })
          this.editing = false
        })
        .catch((err) => {
          console.log('err \n', err)
          this.getOfficeConsultationPrice()
          this.handleError(err)
        })
        .finally(() => {
          this.isEditing = false
          this.fn_HIDE_PROGRESS()
        })
    },

    findErrorMessage (object) {
      let errorMessage = null
      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }
      if (Array.isArray(object)) {
        object.forEach((element) => recursiveSearch(element))
      } else {
        recursiveSearch(object)
      }
      return errorMessage
    },

    handleError (err) {
      const msg = (typeof err !== 'object')
        ? err
        : ('errors' in err)
          ? this.findErrorMessage(err.errors)
          : 'Ocorreu um erro.'

      this.$store.dispatch('setModalAlert', {
        title: 'Erro',
        body: Array.isArray(msg) ? msg[0] : msg,
        size: 'md',
        active: true
      })
    }
  }
}
</script>
